import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ContentfulPage from "../../../contentful/ContentfulPage";
import { useUser, useExperiment } from "xAppLib/Hooks";
import LoggedInHomepage from "./LoggedInHomepage";
import { Loader } from "semantic-ui-react";
import { useEffect } from "react";
import { WAIT_TIME_EXP } from "./consts";
import { PAGE_IDS } from "@iscr/contentful/constants";
import { useLocation } from "react-router-dom";
const HomepageWrapper = ({ popup }) => {
    const user = useUser();
    const user_in = user.user_in;
    //@ts-ignore
    const loc = useLocation();
    const loading = app.settings.is_ionic && !app.state.loaded;
    const isStaff = app.acl.is_work;
    const waitTimeExp = useExperiment(WAIT_TIME_EXP, { quiet: (loc === null || loc === void 0 ? void 0 : loc.state) === "logout" || isStaff });
    useEffect(() => {
        if (popup)
            app.trigger(app.events.SHOW_POPUP, popup);
    }, [popup]);
    useEffect(() => {
        var _a, _b, _c;
        // Skipping staff also stops them setting the session flag and blocking the impression when they log
        // out and browse as a patient
        if (!(waitTimeExp === null || waitTimeExp === void 0 ? void 0 : waitTimeExp.n) || app.dev_env || isStaff)
            return;
        const exp = JSON.parse((_a = sessionStorage.getItem("exp")) !== null && _a !== void 0 ? _a : "{}");
        if (!((_b = exp === null || exp === void 0 ? void 0 : exp[WAIT_TIME_EXP]) === null || _b === void 0 ? void 0 : _b.im) && (loc === null || loc === void 0 ? void 0 : loc.state) !== "logout") {
            ((_c = exp[WAIT_TIME_EXP]) !== null && _c !== void 0 ? _c : (exp[WAIT_TIME_EXP] = {})).im = true;
            sessionStorage.setItem("exp", JSON.stringify(exp));
            waitTimeExp === null || waitTimeExp === void 0 ? void 0 : waitTimeExp.f();
        }
    }, [waitTimeExp === null || waitTimeExp === void 0 ? void 0 : waitTimeExp.n]);
    if (loading) {
        return _jsx(Loader, { active: true });
    }
    return (_jsx(_Fragment, { children: user_in ? (_jsx(LoggedInHomepage, { exp: { waitTimeExp } })) : (_jsx(_Fragment, { children: _jsx(ContentfulPage, { contentTag: PAGE_IDS.LANDING_PAGE, identifier: PAGE_IDS.HOMEPAGE, isStatic: false }) })) }));
};
export default HomepageWrapper;
